import { Keuzehulp } from '../keuzehulpen'

const depressie: Keuzehulp = {
  title: 'Depressie',
  basePath: '/depressie',
  documentTitle: 'Depressie',
  routes: [
    {
      path: '',
      routeId: 'P16-001',
      nextRouteId: 'P16-002',
      type: 'intro',
      title: 'Voordat je begint…',
      backButton:
        'https://www.thuisarts.nl/keuzehulp/ik-heb-depressie-welke-behandeling-past-bij-mij',
      columns: [
        {
          title: 'Neem de tijd',
          description: 'Neem alle tijd die je nodig hebt om de keuzehulp in te vullen',
        },
        {
          title: '20 minuten',
          description: 'Zo lang zijn de meeste mensen bezig met deze keuzehulp',
        },
        {
          title: 'Zoek een rustige plek',
          description: 'Zodat je goed jouw aandacht erbij kunt houden',
        },
        {
          title: 'Stop niet tussendoor',
          description:
            'Je antwoorden worden niet bewaard. De keuzehulp onthoudt niet waar je gebleven bent',
        },
      ],
    },
    {
      path: '/stap-1',
      routeIndex: '1',
      routeId: 'P16-002',
      nextRouteId: 'P16-003',
      type: 'chapter',
      title: 'Wat is een depressie?',
      subtitle: 'Stap 1',
      description: `
        <p>Je hebt van je arts gehoord dat je een depressie hebt. Wat betekent dat?</p>`,
      image: {
        src: `${process.env.PUBLIC_URL}/img/depressie-stap-1.webp`,
        alt: '',
      },
      button: 'Start de keuzehulp',
    },
    {
      path: '/stap-1/wat-is-een-depressie',
      routeId: 'P16-003',
      nextRouteId: 'P16-004',
      type: 'explanation',
      title: 'Wat is een depressie?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>
            Bij een depressie heb je in elk geval 1 of 2 van deze klachten:
          </p>
          <ul>
            <li>somber zijn</li>
            <li>bijna nergens meer zin of plezier in hebben. Ook niet in dingen die je eerst wel leuk vond.</li>
          </ul>

          <p>
            En je hebt daarbij nog 3 of meer van deze klachten:
          </p>
          <ul>
            <li>je waardeloos of leeg voelen</li>
            <li>heel moe zijn</li>
            <li>je slecht kunnen concentreren</li>
            <li>geen beslissingen kunnen nemen</li>
            <li>je sloom voelen</li>
            <li>geen energie hebben om te bewegen</li>
            <li>snel veel zwaarder worden</li>
            <li>snel veel afvallen</li>
            <li>niet goed kunnen slapen</li>
            <li>heel veel slapen</li>
            <li>een onrustig gevoel hebben of steeds willen bewegen</li>
            <li>niet meer willen leven, denken aan de dood of %ZELFMOORD%</li>
            <li>door je klachten kun je je normale dingen niet meer doen. Bijvoorbeeld je werk of dingen die je in je vrije tijd deed.</li>
          </ul>

          <p>Als je dit 2 weken of langer bijna de hele dag hebt, kun je een depressie hebben.</p>
          <p>Veel mensen krijgen een depressie. Het is niet iets om je voor te schamen of je schuldig over te voelen. Het kan goed behandeld worden. Daarom is het belangrijk om snel hulp te vragen.
          </p>
        </div>
      `,
      button: 'Ga verder',
      modalLinks: [
        {
          key: 'ZELFMOORD',
          title: 'Zoek hulp',
          link: 'zelfmoord',
          content: `
            <div>
              <p>
                Bel direct de huisarts, de huisartsenpost of 112 als je nu een einde aan je leven wilt maken.
              </p>
              <p>
                Denk je veel aan de dood of aan zelfmoord? Ga dan op zoek naar hulp.
                Bel je arts of de persoon die je behandelt.
                Je kunt ook dag en nacht 113 of 0800-0113 (gratis) bellen.
                Of met iemand chatten via 113.nl. Dit is anoniem.
                Je hoeft alleen te zeggen hoe je heet.
                En als je dat niet wilt, kun je een naam verzinnen.
              </p>
            </div>
          `,
        },
      ],
    },
    {
      path: '/stap-1/film-over-depressie',
      routeId: 'P16-004',
      nextRouteId: 'P16-005',
      type: 'explanation',
      title: 'Film over depressie',
      align: 'center',
      titleAlign: 'center',
      button: 'Ga verder',
      videos: [
        {
          src: 'https://media.thuisarts.nl/depressie.mp4',
          soundSrc: 'https://media.thuisarts.nl/depressie.mp3',
          poster: 'https://media.thuisarts.nl/depressie.jpg',
          videoSize: '30mb',
          subtitles: [
            {
              default: true,
              kind: 'subtitles',
              srclang: 'nl',
              label: 'Dutch',
              src: 'https://media.thuisarts.nl/depressie.vtt',
              subtitleSize: '5kb',
            },
          ],
        },
      ],
    },
    {
      path: '/stap-1/wat-kun-je-doen-bij-een-depressie',
      routeId: 'P16-005',
      nextRouteId: 'P16-006',
      type: 'explanation',
      title: 'Wat kun je doen bij een depressie?',
      align: 'left',
      titleAlign: 'center',
      modalLinks: [
        {
          link: 'lichte depressie',
          key: 'LICHTE_DEPRESSIE',
          title: 'Lichte depressie',
          content: `
            <div>
              <p>
                Bij een lichte depressie lukt het je vaak nog wel om je dagelijkse dingen te doen. Een lichte depressie kan vanzelf overgaan.
              </p>
            </div>
          `,
        },
        {
          link: 'ernstige depressie',
          key: 'ERNSTIGE_DEPRESSIE',
          title: 'Ernstige depressie',
          content: `
            <div>
              <p>
                Bij een ernstige depressie lukt het je niet meer om je dagelijkse dingen te doen. Je hebt snel hulp nodig van een ervaren hulpverlener.
              </p>
            </div>
          `,
        },
      ],

      description: `
        <div>
          <p>
            Bij een depressie kun je zelf een aantal dingen doen om je beter te voelen.
            Gesprekken met de huisarts of de praktijkondersteuner kunnen ook helpen.
            Bij een %LICHTE_DEPRESSIE% is dat soms al genoeg.
          </p>

          <p>
            Bij een %ERNSTIGE_DEPRESSIE% is meer behandeling nodig.
            Je bespreekt samen met je arts welke behandeling dan bij jou past.
          </p>

          <p>
            Het is goed om te weten dat het een tijd kan duren voordat je je beter voelt.
            Een depressie kan maanden duren.
            Van de 10 mensen met een depressie voelen 5 zich binnen een half jaar weer beter.
            Door een behandeling kun je je soms sneller beter voelen.
            Maar het is niet je eigen schuld als dat niet lukt.
          </p>
        </div>
      `,
      button: 'Ga verder',
    },

    {
      path: '/stap-1/vraag-1',
      routeId: 'P16-006',
      nextRouteId: 'P16-008', // P16-007 does not exist
      subtitle: 'Maak een keuze',
      title: 'Waar wil je meer over weten?',
      description:
        '<p>Klik hieronder aan welke onderwerpen voor jou belangrijk zijn. Wil je alles lezen, klik dan alles aan.</p>',
      descriptionAlign: 'left',
      type: 'question',
      hideFromOverview: true,
      questions: [
        {
          type: 'multiple',
          answers: [
            {
              title: 'Dingen die je zelf kunt doen om je beter te voelen',
              showChapter: '2',
            },
            {
              title: 'Behandeling door de huisarts of praktijkondersteuner',
              showChapter: '3',
            },
            {
              title: 'Andere behandelingen',
              showChapter: '4',
            },
          ],
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-2',
      routeIndex: '2',
      routeId: 'P16-008',
      nextRouteId: 'P16-009',
      type: 'chapter',
      title: 'Dingen die je zelf kunt doen om je beter te voelen',
      subtitle: 'Stap 2',
      description: `
        <p>
          Als je een depressie hebt, kun je altijd zelf een aantal dingen doen om je beter te voelen.
          Je hoeft niet alles in 1 keer te veranderen.
          Kies zelf waar je mee gaat beginnen. En begin rustig aan.
          Bedenk dat elke kleine verandering al helpt.
        </p>
      `,
      image: {
        src: `${process.env.PUBLIC_URL}/img/depressie-stap-2.webp`,
        alt: '',
      },
      button: 'Ga verder',
    },

    {
      path: '/stap-2/vraag-1',
      routeId: 'P16-009',
      nextRouteId: 'P16-011', // P16-010 does not exist
      type: 'question',
      hideFromOverview: true,
      title: 'Waar wil je meer over weten?',
      description:
        '<p>Klik hieronder aan welke onderwerpen voor jou belangrijk zijn. Wil je alles lezen, klik dan alles aan.</p>',
      descriptionAlign: 'left',
      questions: [
        {
          type: 'multiple',
          answers: [
            {
              title: 'Elke dag dingen op vaste tijden doen',
              showChapter: '2.2',
            },
            {
              title: 'Gezond eten',
              showChapter: '2.3',
            },
            {
              title: 'Bewegen en sporten',
              showChapter: '2.4',
            },
            {
              title: 'Stoppen met alcohol of drugs',
              showChapter: '2.5',
            },
            {
              title: 'Contact houden met anderen',
              showChapter: '2.6',
            },
            {
              title: 'Doorgaan met werk',
              showChapter: '2.7',
            },
            {
              title: 'Doorgaan met studie',
              showChapter: '2.8',
            },
            {
              title: 'Een lijst maken met dingen om te doen',
              showChapter: '2.9',
            },
          ],
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-2/elke-dag-dingen-op-vaste-tijden-doen',
      routeId: 'P16-011',
      nextRouteId: 'P16-012',
      routeIndex: '2.2',
      type: 'explanation',
      title: 'Elke dag dingen op vaste tijden doen',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>
            Het is belangrijk om dingen op vaste tijden te doen. Bijvoorbeeld:
          </p>

          <ul>
            <li>Sta op tijd op.</li>
            <li>Eet elke dag op dezelfde tijden.</li>
            <li>Ga elke dag naar buiten. Buitenlucht en bewegen kunnen je een beter gevoel geven.</li>
            <li>Ga elke dag op tijd naar bed. En het liefst op een vaste tijd. Dat is belangrijk voor je slaap en je stemming.</li>
          </ul>

          <p>
            Je hoeft niet direct alles te veranderen. Bedenk 1 ding waar jij mee wilt beginnen. Dan kun je het beter volhouden.
          </p>
        </div>
      `,
      image: {
        src: `${process.env.PUBLIC_URL}/img/depressie-stap-2_2.webp`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-2/vraag-2',
      routeId: 'P16-012',
      routeIndex: '2.2.1',
      nextRouteId: 'P16-013',
      type: 'question',
      hideFromOverview: false,
      title: 'Het is goed om dingen op vaste tijden te doen. Waar ga jij mee beginnen?',
      description: '<p>Schrijf je antwoord in het tekstvlak.</p>',
      descriptionAlign: 'left',
      questions: [
        {
          type: 'textarea',
          placeholder: 'Schrijf hier je antwoord',
          title: 'Antwoord',
        },
      ],
      showTextArea: true,
      button: 'Volgende',
    },
    {
      path: '/stap-2/gezond-eten',
      routeId: 'P16-013',
      nextRouteId: 'P16-014',
      routeIndex: '2.3',
      type: 'explanation',
      title: 'Gezond eten',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>
            Door gezond eten kun je je beter voelen:
          </p>

          <ul>
            <li>Eet regelmatig, eet elke dag 3 gezonde maaltijden.</li>
            <li>Neem kleine gezonde tussendoortjes. Bijvoorbeeld een schaaltje rauwkost of een handje noten.</li>
            <li>Eet vooral producten die vers en niet bewerkt zijn. Bijvoorbeeld verse groente, vers fruit, noten, verse kruiden en vette vis.</li>
            <li>
              Kies liever geen bewerkte producten zoals kant-en-klare maaltijden, sauzen en soepen, frisdrank, snoep, chips en koekjes.
              ‘Bewerkt’ betekent dat er in de fabriek iets met het product gedaan is. Bijvoorbeeld om het langer houdbaar te maken.
              In bewerkt eten en drinken zit vaak veel suiker, zout en vet. Dat is niet gezond. Staan er veel ingrediënten op een verpakking? Dan is het product vaak erg bewerkt.
            </li>
          </ul>

          <p>
            Wil je meer tips over gezond eten?
          </p>
        </div>
      `,
      videos: [
        {
          src: 'https://media.thuisarts.nl/zvm-gezond-eten.mp4',
          soundSrc: 'https://media.thuisarts.nl/zvm-gezond-eten.mp3',
          poster: 'https://media.thuisarts.nl/zvm-gezond-eten.jpg',
          videoSize: '30mb',
          subtitles: [
            {
              default: true,
              kind: 'subtitles',
              srclang: 'nl',
              label: 'Dutch',
              src: 'https://media.thuisarts.nl/zvm-gezond-eten.vtt',
              subtitleSize: '4kb',
            },
          ],
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-2/vraag-3',
      routeId: 'P16-014',
      nextRouteId: 'P16-015',
      routeIndex: '2.3.1',
      type: 'question',
      hideFromOverview: false,
      title:
        'Het is goed om gezonder te eten. Waar ga jij mee beginnen? Of waar ga jij mee stoppen?',
      description: '<p>Schrijf je antwoord in het tekstvlak.</p>',
      descriptionAlign: 'left',
      questions: [
        {
          type: 'textarea',
          placeholder: 'Schrijf hier je antwoord',
          title: 'Antwoord',
        },
      ],
      showTextArea: true,
      textAreaLabel: 'Waarom wil je dat het liefst?',
      button: 'Volgende',
    },
    {
      path: '/stap-2/bewegen-en-sporten',
      routeId: 'P16-015',
      nextRouteId: 'P16-016',
      routeIndex: '2.4',
      type: 'explanation',
      title: 'Bewegen en sporten',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>
            Bewegen en sporten zijn belangrijk om je beter te voelen:
          </p>

          <ul>
            <li>Probeer een half uur per dag te bewegen. Lukt dat niet, begin dan rustig aan en ga langzaam steeds iets meer doen.</li>
            <li>Ga bijvoorbeeld wandelen of tuinieren. Of loop of fiets naar de winkel voor je boodschappen.</li>
            <li>Probeer ook te gaan sporten. Vooral hardlopen helpt om je beter te voelen. Stevig wandelen of hard fietsen is ook goed. En je kunt bijvoorbeeld ook zwemmen of dansen. Je hart moet wel wat sneller gaan kloppen en je moet wat sneller gaan ademen. Dat heet matig intensief bewegen. Dit helpt om je minder depressief en fitter te voelen. Ook zorgt het ervoor dat je beter slaapt.</li>
          </ul>
        </div>
      `,
      videos: [
        {
          src: 'https://media.thuisarts.nl/zvm-meer-bewegen.mp4',
          soundSrc: 'https://media.thuisarts.nl/zvm-meer-bewegen.mp3',
          poster: 'https://media.thuisarts.nl/zvm-meer-bewegen.jpg',
          videoSize: '30mb',
          subtitles: [
            {
              default: true,
              kind: 'subtitles',
              srclang: 'nl',
              label: 'Dutch',
              src: 'https://media.thuisarts.nl/zvm-meer-bewegen.vtt',
              subtitleSize: '4kb',
            },
          ],
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-2/vraag-4',
      routeId: 'P16-016',
      nextRouteId: 'P16-017',
      routeIndex: '2.4.1',
      type: 'question',
      hideFromOverview: false,
      title: 'Het is goed om te bewegen en te sporten. Wat past bij jou?',
      description: `
        <div>
          <p>
            Denk na over deze dingen:
          </p>

          <ul>
            <li>Wat past bij jou? Wandelen, fietsen, tuinieren of een sport?</li>
            <li>Op welke tijden wil je dit gaan doen?</li>
            <li>Wanneer ga je beginnen?</li>
          </ul>

          <p>
            Schrijf je antwoord in het tekstvlak
          </p>
        </div>
      `,
      descriptionAlign: 'left',
      questions: [
        {
          type: 'textarea',
          placeholder: 'Schrijf hier je antwoord\n',
          title: 'Antwoord',
        },
      ],
      showTextArea: true,
      button: 'Volgende',
    },
    {
      path: '/stap-2/alcohol-of-drugs',
      routeId: 'P16-017',
      nextRouteId: 'P16-018',
      routeIndex: '2.5',
      type: 'explanation',
      title: 'Alcohol of drugs',
      align: 'left',
      titleAlign: 'center',
      description: `
        <p>
          Drink geen alcohol, gebruik geen xtc, blow niet, gebruik geen lachgas en neem geen andere drugs. Dit is belangrijk om je weer beter te voelen. Alcohol en drugs kunnen je klachten erger maken.
        </p>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-2/vraag-5',
      routeId: 'P16-018',
      nextRouteId: 'P16-019',
      routeIndex: '2.5.1',
      type: 'question',
      hideFromOverview: false,
      title:
        'Om je beter te voelen, is het belangrijk dat je geen alcohol of drugs gebruikt. Waar ga jij mee stoppen?',
      description: `
        <div>
          <p>
            Denk na over deze dingen:
          </p>
          <ul>
            <li>Wanneer ga je stoppen?</li>
            <li>Heb je hulp nodig om te stoppen?</li>
          </ul>
        </div
      `,
      descriptionAlign: 'left',
      questions: [
        {
          type: 'textarea',
          placeholder: 'Schrijf hier je antwoord',
          title: 'Antwoord',
        },
      ],
      showTextArea: true,
      textAreaLabel: 'Waarom wil je dat het liefst?',
      button: 'Volgende',
    },
    {
      path: '/stap-2/contact-met-anderen',
      routeId: 'P16-019',
      nextRouteId: 'P16-020',
      routeIndex: '2.6',
      type: 'explanation',
      title: 'Contact met anderen',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>
            Het kan helpen om te praten met mensen die zelf ook een depressie hebben. Of met mensen die een depressie hebben gehad. Je kunt deze mensen vinden via de Depressie Vereniging. Aan het einde van deze keuzehulp vind je een link naar de Depressie Vereniging.
          </p>

          <p>
            Heb je zelf mensen om je heen met wie je kunt praten? Bijvoorbeeld een familielid, vriend, buur of collega?
            Spreek ook af om regelmatig iemand te bellen of om bij iemand op bezoek te gaan.
            Vaak helpt het om over je depressie te praten.
          </p>

          <p>
            Leg mensen uit wat er met je is. De meeste mensen zullen het begrijpen.
            Sommige mensen zullen het niet begrijpen.
            Dat is nu eenmaal zo. Probeer dat te accepteren.
          </p>

          <p>
            Door de depressie ga je misschien negatief over jezelf denken.
            Praat erover met anderen. Meestal veranderen deze gevoelens na een tijdje.
            Ook doordat je er veel over praat.
          </p>
        </div>
      `,
      image: {
        src: `${process.env.PUBLIC_URL}/img/depressie-stap-2_6.webp`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-2/vraag-6',
      routeId: 'P16-020',
      nextRouteId: 'P16-021',
      routeIndex: '2.6.1',
      type: 'question',
      hideFromOverview: false,
      title: 'Met wie ga jij contact houden?',
      description: '<p>Schrijf je antwoord in het tekstvlak</p>',
      descriptionAlign: 'left',
      questions: [
        {
          type: 'textarea',
          placeholder: 'Schrijf hier je antwoord',
          title: 'Antwoord',
        },
      ],
      showTextArea: true,
      textAreaLabel: 'Waarom wil je dat het liefst?',
      button: 'Volgende',
    },
    {
      path: '/stap-2/blijven-werken',
      routeId: 'P16-021',
      nextRouteId: 'P16-022',
      routeIndex: '2.7',
      type: 'explanation',
      title: 'Blijven werken',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>
            Blijven werken is vaak beter dan een tijdje stoppen met werken.
          </p>

          <p>
            Bel of mail met je bedrijfsarts om te bespreken hoe je kunt blijven werken. Soms moet er iets veranderen aan je werk. Je gaat bijvoorbeeld halve dagen werken, of je doet alleen de taken die voor jou makkelijk zijn.
          </p>

          <p>
            Moet je toch tijdelijk stoppen met werken? Bespreek dan samen hoe je zo snel mogelijk weer aan het werk kunt. Je herstelt sneller en beter als je blijft werken.
          </p>
        </div>
      `,
      image: {
        src: `${process.env.PUBLIC_URL}/img/depressie-stap-2_7.webp`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-2/vraag-7',
      routeId: 'P16-022',
      nextRouteId: 'P16-023',
      routeIndex: '2.7.1',
      type: 'question',
      hideFromOverview: false,
      title:
        'Het is goed om te blijven werken, al is het maar voor een paar uur. Wat heb jij nodig om aan het werk te blijven?',
      description: `
        <div>
          <p>
            Denk na over deze dingen:
          </p>

          <ul>
            <li>Welke taken kun je nog wel doen?</li>
            <li>Hoeveel uur denk je te kunnen werken?</li>
            <li>Kun je beter thuis werken?</li>
            <li>Of wil je juist liever contact met collega’s?</li>
          </ul>

          <p>
            Schrijf je antwoord in het tekstvlak:
          </p>
        </div>
      `,
      descriptionAlign: 'left',
      questions: [
        {
          type: 'textarea',
          placeholder: 'Schrijf hier je antwoord',
          title: 'Antwoord',
        },
      ],
      showTextArea: true,
      textAreaLabel: 'Waarom wil je dat het liefst?',
      button: 'Volgende',
    },
    {
      path: '/stap-2/blijven-studeren',
      routeId: 'P16-023',
      nextRouteId: 'P16-024',
      routeIndex: '2.8',
      type: 'explanation',
      title: 'Blijven studeren',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>
            Blijven studeren is vaak beter dan een tijdje stoppen met studeren.
          </p>

          <p>
            Bespreek met je mentor of decaan hoe je kunt blijven studeren. Soms moet er misschien iets veranderen aan je studie. Je gaat bijvoorbeeld wat minder doen.
            Moet je toch tijdelijk stoppen met studeren? Bespreek dan samen hoe je zo snel mogelijk weer kunt beginnen. Je voelt je sneller beter als je iets aan je studie blijft doen.
          </p>
        </div>
      `,
      image: {
        src: `${process.env.PUBLIC_URL}/img/depressie-stap-2_8.webp`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-2/vraag-8',
      routeId: 'P16-024',
      nextRouteId: 'P16-025',
      routeIndex: '2.8.1',
      type: 'question',
      hideFromOverview: false,
      title: 'Wat heb jij nodig om te blijven studeren?',
      description: `
        <div>
          <p>Denk na over deze dingen:</p>

          <ul>
            <li>Hoeveel uur denk je te kunnen studeren?</li>
            <li>Kun je beter online lessen volgen?</li>
            <li>Of wil je juist liever contact met andere studenten?</li>
            <li>Wil je aan werkgroepen of praktijklessen meedoen?</li>
            <li>Wil je toetsen doen of juist liever overslaan?</li>
          </ul>

          <p>Schrijf je antwoord in het tekstvlak:</p>
        </div>
      `,
      descriptionAlign: 'left',
      questions: [
        {
          type: 'textarea',
          placeholder: 'Schrijf hier je antwoord',
          title: 'Antwoord',
        },
      ],
      showTextArea: true,
      textAreaLabel: 'Waarom wil je dat het liefst?',
      button: 'Volgende',
    },
    {
      path: '/stap-2/een-lijst-maken-van-dingen-die-je-gaat-doen',
      routeId: 'P16-025',
      nextRouteId: 'P16-026',
      routeIndex: '2.9',
      type: 'explanation',
      title: 'Een lijst maken met dingen die je gaat doen',
      align: 'left',
      titleAlign: 'center',
      description: `
        <p>
          Als je een depressie hebt, kan het heel moeilijk zijn om dingen te gaan doen.
          Maak daarom voor jezelf een lijst met dingen die je kunt gaan doen.
          Op deze lijst kun je bijvoorbeeld zetten hoe laat je wilt opstaan en hoe laat je wilt eten.
          Maar je kunt er ook andere dingen op zetten.
        </p>
      `,
      image: {
        src: `${process.env.PUBLIC_URL}/img/depressie-stap-2_9.webp`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-2/vraag-9',
      routeId: 'P16-026',
      routeIndex: '2.9.1',
      nextRouteId: 'P16-027',
      type: 'question',
      hideFromOverview: false,
      title: 'Welke dingen zou je willen gaan doen?',
      description: `
        <div>
          <p>
            Kies iets wat je prettig vindt of vond om te doen.
            Bijvoorbeeld een tijdschrift lezen, een stukje wandelen of een film kijken.
            Schrijf op waar je mee gaat beginnen.
          </p>

          <p>
            Schrijf je antwoord in het tekstvlak
          </p>
        </div>
      `,
      descriptionAlign: 'left',
      questions: [
        {
          type: 'textarea',
          placeholder: 'Schrijf hier je antwoord',
          title: 'Antwoord',
        },
      ],
      showTextArea: true,
      textAreaLabel: 'Waarom wil je dat het liefst?',
      button: 'Volgende',
    },
    {
      path: '/stap-3',
      routeIndex: '3',
      routeId: 'P16-027',
      nextRouteId: 'P16-028',
      type: 'chapter',
      title: 'Behandeling door praktijkondersteuner of huisarts',
      subtitle: 'Stap 3',
      description: `
        <p>
          Heb je hulp nodig om je beter te voelen? Bel dan de huisarts.
          Die kan jou zelf verder helpen of je doorsturen naar de praktijkondersteuner voor psychische klachten (poh-ggz).
          Een praktijkondersteuner werkt in je huisartsenpraktijk. Als het nodig is, overlegt die met de huisarts.
        </p>
      `,
      image: {
        src: `${process.env.PUBLIC_URL}/img/depressie-stap-3.webp`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-3/wat-kan-de-praktijkondersteuner-of-de-huisarts-doen',
      routeId: 'P16-028',
      nextRouteId: 'P16-029',
      type: 'explanation',
      title: 'Wat kan de praktijkondersteuner of de huisarts doen?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>
            Je huisarts of praktijkondersteuner luistert naar je. Ook krijg je uitleg over je klachten en wat je er zelf aan kunt doen.
            De huisarts of praktijkondersteuner kan je ook een behandeling geven of een behandeling adviseren.
            </br>
            Bijvoorbeeld:
          </p>

          <h2 style="font-size: 18px; margin-bottom: 0; line-height: 1.6;">Dingen gaan doen</h2>
          <p>
            Je gaat met hulp van de praktijkondersteuner dingen bedenken die je leuk vond om te doen:
            je maakt een activiteiten-lijst. Die dingen ga je doen. Daarna kijk je hoe je je voelt. <br />
            Zo merk je dat je je beter voelt door dingen te doen.
          </p>

          <h2 style="font-size: 18px; margin-bottom: 0; line-height: 1.6;">Je gedachten en je gedrag veranderen</h2>
          <p>
            Heb je veel last van negatieve gedachten? Je kunt leren om die te veranderen. Dit heet cognitieve gedragstherapie.<br />
            Eerst onderzoek je je gedachten. Zijn ze eigenlijk wel waar? En helpen ze je, of niet? Je bedenkt welke gedachten beter kloppen en jou wel kunnen helpen. Die gedachten kun je tegen jezelf zeggen in moeilijke situaties.
          </p>

          <h2 style="font-size: 18px; margin-bottom: 0; line-height: 1.6;">ACT</h2>
          <p>
            Met de therapie ACT leer je dat gedachten komen en gaan. En dat gedachten niet de waarheid zijn. Ook leer je moeilijke gevoelens voelen en accepteren. Zo voel je meer ruimte om te doen wat voor jou echt belangrijk is in je leven.<br />
            ACT is de afkorting van Acceptatie en Commitment Therapie.
          </p>

          <h2 style="font-size: 18px; margin-bottom: 0; line-height: 1.6;">Omgaan met problemen</h2>
          <p>
            Sommige problemen kun je niet zelf oplossen. Je kunt er wel mee om leren gaan. Je leert manieren hoe je dit kunt doen.<br />
            De behandeling heet Problem Solving Treatment (PST).
          </p>

          <h2 style="font-size: 18px; margin-bottom: 0; line-height: 1.6;">Mindfulness en je gedachten en gedrag veranderen</h2>
          <p>
            Je leert om in het hier en nu te zijn. Je krijgt meditatie-oefeningen. Je leert ook je gedachten en gedrag veranderen.<br />
            Deze hulp past vooral bij jou als je vaker depressieve periodes hebt.<br />
            Deze behandeling heet mindfulness-based cognitieve therapie (MBCT).
          </p>

          <h2 style="font-size: 18px; margin-bottom: 0; line-height: 1.6;">Digitale behandeling</h2>
          <p>
            Soms kun je een deel van de behandeling digitaal volgen. De praktijkondersteuner bespreekt dan met je of dit bij jou past. 
          </p>

          <h2 style="font-size: 18px; margin-bottom: 0; line-height: 1.6;">Meer bewegen</h2>
          <p>
            Bewegen helpt om je beter te voelen. Er zijn groepen en therapeuten speciaal voor mensen met een depressie. Bijvoorbeeld een wandelgroep. Of running-therapie.<br />
            Je huisarts kan je doorsturen naar een groep of therapeut in de buurt.
          </p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/hoe-gaat-het-verder',
      routeId: 'P16-029',
      nextRouteId: 'P16-030',
      type: 'explanation',
      title: 'Hoe gaat het verder?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>
            Je bespreekt met de huisarts of praktijkondersteuner of de behandeling genoeg helpt.
            Is dat niet zo, dan kijk je samen naar wat er nog meer kan.
          </p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-1',
      routeId: 'P16-030',
      nextRouteId: 'P16-031',
      type: 'question',
      hideFromOverview: false,
      title: 'Welke vragen heb jij voor de praktijkondersteuner of de huisarts?',
      description: `
        <p>
          Schrijf hieronder op welke vragen je hebt.
        </p>
      `,
      descriptionAlign: 'left',
      questions: [
        {
          type: 'textarea',
          title: 'Vragen',
        },
      ],
      showTextArea: true,
      textAreaLabel: 'Waarom wil je dat het liefst?',
      button: 'Volgende',
    },
    {
      path: '/stap-4',
      routeIndex: '4',
      routeId: 'P16-031',
      nextRouteId: 'P16-032',
      type: 'chapter',
      title: 'Andere behandelingen',
      subtitle: 'Stap 4',
      description: `
        <p>
          Soms helpen de adviezen en de gesprekken met de huisarts of de praktijkondersteuner niet genoeg.
          Dan kan de huisarts je doorsturen voor een behandeling.
        </p>
      `,
      image: {
        src: `${process.env.PUBLIC_URL}/img/depressie-stap-4.webp`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-4/andere-behandelingen',
      routeId: 'P16-032',
      nextRouteId: 'P16-033',
      type: 'explanation',
      title: 'Andere behandelingen',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>
            Dit zijn de behandelingen die je kunt krijgen:
          </p>
          <ul>
            <li>
              behandeling door een psycholoog (psychotherapie)
              <br>
              De psycholoog die je kiest moet op een speciale lijst staan van de overheid (BIG-register).
              Psychologen die op deze lijst staan hebben een goede opleiding en kunnen jou goed behandelen.
            </li>
            <li>
              medicijnen (antidepressiva)
            </li>
            <li>
              een combinatie van psychotherapie en medicijnen
            </li>
          </ul>

          <p>
            Elke behandeling heeft voordelen en nadelen.
            Hoe belangrijk die voordelen en nadelen zijn, verschilt per persoon.
            Je praat erover met je arts. Je kunt bijvoorbeeld deze vragen stellen:
          </p>
          <ul>
            <li>Hoe snel gaat de behandeling werken?</li>
            <li>Waar kan ik last van krijgen?</li>
            <li>Welke invloed heeft de behandeling op mijn leven?</li>
            <li>Is er een wachtlijst voor?</li>
          </ul>

          <p>
            Samen met je arts kies je de behandeling.
          </p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-4/behandeling-door-een-psycholoog',
      routeId: 'P16-033',
      nextRouteId: 'P16-034',
      type: 'explanation',
      title: 'Behandeling door een psycholoog',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>
            Je hebt gesprekken met een psycholoog.
            Dit heet gesprekstherapie of psychotherapie.
          </p>
          <p>
            Je praat over je klachten en over hoe ze zijn gekomen. Je leert wat je kunt doen om anders te denken en je beter te voelen. Je gaat daarmee oefenen.
          </p>
          <p>
            Kijk hier welke behandelingen je kunt krijgen bij de psycholoog.
          </p>
        </div>
      `,
      image: {
        src: `${process.env.PUBLIC_URL}/img/depressie-stap-4_2.webp`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-4/ik-wil-graag-meer-weten-over',
      routeId: 'P16-034',
      nextRouteId: 'P16-035',
      type: 'popupCards',
      title: 'Ik wil graag meer weten over',
      align: 'left',
      description: '',
      cards: [
        {
          cardTitle: 'Cognitieve gedragstherapie',
          readingTime: '2 minuten leestijd',
          modalContent: `
            <div>
              <p>
                Bij cognitieve gedragstherapie zoek je samen met je psycholoog uit welke gedachten jou somber maken.
                Dat kunnen bijvoorbeeld dit soort gedachten zijn: ‘Niemand vindt mij aardig’ of ‘Ik kan niks’.
                Als je zo over jezelf denkt, kun je daar erg somber door worden.
                In de therapie onderzoek je waarom je zo over jezelf denkt en of die gedachten over jezelf kloppen.
                Je gaat oefenen om in sommige situaties anders te denken en je anders te gedragen.
                Hierdoor ga je ook positiever over jezelf denken. Je klachten worden minder.
                Je voelt je sterker en veiliger.
              </p>
            </div>
          `,
        },
        {
          cardTitle: 'Gedragstherapie',
          readingTime: '1 minuut leestijd',
          modalContent: `
            <div>
              <p>
                Mensen met een depressie gaan vaak steeds minder doen.
                Hierdoor wordt de depressie alleen maar erger.
                Tijdens de therapie ga je dit gedrag proberen te veranderen.
                Samen met je therapeut maak je een plan om langzaam weer op een ontspannen manier dingen te gaan doen.
                Of om andere, leukere dingen te gaan doen. Hierdoor ga je je na een tijdje beter voelen.
                Je merkt dat dingen ook weer goed kunnen gaan en krijgt weer plezier in dingen.
              </p>

              <p>
                Er is ook aandacht voor het contact met andere mensen.
                Als je een depressie hebt, voelt het vaak niet fijn om met andere mensen te zijn.
                Daardoor ga je bijvoorbeeld niet meer sporten of naar feestjes toe.
                Tijdens de behandeling leer je wat je kunt doen om je wel prettig te voelen bij anderen.
                Je gaat hiermee ook oefenen.
              </p>
            </div>
          `,
        },
        {
          cardTitle: 'Interpersoonlijke therapie',
          readingTime: '1 minuut leestijd',
          modalContent: `
            <div>
              <p>
                Bij interpersoonlijke therapie gaat het over jouw contact met andere mensen.
                Soms komt een depressie doordat je het moeilijk vindt om met andere mensen om te gaan.
                Of doordat jouw contact met anderen is veranderd. Bijvoorbeeld in deze situaties:
              </p>

              <ul>
                <li>Iemand van wie je houdt, is overleden.</li>
                <li>Je bent met pensioen gegaan.</li>
                <li>Je bent gescheiden.</li>
                <li>Je hebt ruzie met iemand die belangrijk voor je is.</li>
              </ul>

              <p>
                Met je therapeut zoek je uit wat bij jou de oorzaken zijn. En je bespreekt waar je aan wilt werken.
              </p>
            </div>
          `,
        },
        {
          cardTitle: 'Kortdurende psychodynamische therapie',
          readingTime: '1 minuut leestijd',
          modalContent: `
            <div>
              <p>
                Iedereen heeft vroeger manieren geleerd om te reageren op dingen die gebeuren in je leven.
                Die manieren kunnen later problemen geven.
                Bij psychodynamische therapie zoek je met je therapeut uit hoe dat bij jou zit.
                Als je weet waar je problemen vandaan komen, kun je ze beter begrijpen en oplossen.
              </p>
            </div>
          `,
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-4/een-behandeling-bij-de-psycholoog-kiezen',
      routeId: 'P16-035',
      nextRouteId: 'P16-036',
      type: 'explanation',
      title: 'Een behandeling bij de psycholoog kiezen',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>
            Bespreek met je huisarts welke behandeling bij de psycholoog het beste bij je past.
            De huisarts kan je doorsturen naar een psycholoog die deze behandeling geeft.
          </p>
          <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Een psycholoog kiezen</h2>
          <p style="margin-top: 0;">
            Je kunt ook zelf een psycholoog zoeken. De psycholoog die je kiest moet op een speciale lijst staan van de overheid (BIG-register).
            Psychologen die op deze lijst staan hebben een goede opleiding en kunnen jou behandelen.
            Aan het einde van deze keuzehulp vind je een link naar het BIG-register.
            Daar kun je controleren of de psycholoog op deze lijst staat.
          </p>
          <p>
            Op de website van de psycholoog staat vaak hoe de psycholoog werkt en welke behandelingen je er kunt krijgen.
          </p>

          <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Vergoeding</h2>
          <p style="margin-top: 0;">
            Behandeling door een psycholoog wordt vaak vergoed uit de basisverzekering.
            Je krijgt de therapie vergoed als deze dingen kloppen:
          </p>
          <ul style="margin-bottom: 0;">
            <li>Je arts heeft gezegd dat je een depressie hebt.</li>
            <li>Je psycholoog moet op de speciale lijst van de overheid staan (BIG-register).</li>
          </ul>
          <p style="margin-top: 0;">
            De kosten van de behandeling gaan wel af van het eigen risico bij je zorgverzekering.
          </p>

          <p>
            Let op! De zorgverzekering vergoedt niet alle psychologen.
            Vraag het na bij je zorgverzekeraar.
            Het staat soms ook op de website van de psycholoog.
          </p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-4/hoe-gaat-het-verder-als-je-kiest-voor-behandeling-door-een-psycholoog',
      routeId: 'P16-036',
      nextRouteId: 'P16-037',
      type: 'explanation',
      title: 'Hoe gaat het verder als je kiest voor behandeling door een psycholoog?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Vaak kun je na 10 tot 16 gesprekken met de psycholoog weer zelf verder. Als je je in de toekomst nog een keer zo voelt, kun je de adviezen weer gebruiken.</p>

          <p>Soms wordt na een tijdje duidelijk dat gesprekken niet genoeg helpen. Dan is er dus een andere behandeling nodig. Je bespreekt de mogelijkheden met de psycholoog en je huisarts.</p>

          <p>Als je nog geen medicijnen tegen de depressie (antidepressiva) hebt gebruikt, is dat misschien het moment om ze te proberen. Als je al medicijnen tegen een depressie slikt of hebt geslikt, bespreek dan of je misschien beter een ander medicijn kunt gebruiken.</p>

          <p>Soms helpen de behandeling door de psycholoog en de behandeling met medicijnen niet genoeg. Dan kan een gesprek met een andere psycholoog of met een psychiater nodig zijn. Die kijkt dan welke behandeling bij jou het beste is.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-4/hoe-denk-jij-over-behandeling-door-een-psycholoog',
      routeId: 'P16-037',
      nextRouteId: 'P16-038',
      type: 'question',
      title: 'Hoe denk jij over behandeling door een psycholoog?',
      align: 'left',
      titleAlign: 'center',
      descriptionAlign: 'left',
      description: `
        <div>
          <p>En welke therapie denk je dat het beste bij jou past?</p>

          <ul>
            <li>
              cognitieve gedragstherapie
              <br>
              Je zoekt uit welke gedachten jou somber maken.
              Je gaat oefenen om in sommige situaties anders te denken en je anders te gedragen.
            </li>
            <li>
              gedragstherapie
              <br>
              Tijdens de therapie maak je een plan om langzaam weer op een ontspannen manier dingen te gaan doen.
            </li>
            <li>
              interpersoonlijke therapie
              <br>
              Soms komt een depressie doordat je het moeilijk vindt om met andere mensen om te gaan.
              Je zoekt uit hoe dat bij jou komt, en gaat daaraan werken.
            </li>
            <li>
              kortdurende psychodynamische therapie
              <br>
              Je zoekt uit waar jouw problemen vandaan komen, zodat je ze beter kunt oplossen.
            </li>
          </ul>
        </div>
      `,
      questions: [
        {
          type: 'textarea',
          placeholder: 'Schrijf hier je antwoord',
        },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-4/medicijnen-tegen-een-depressie',
      routeId: 'P16-038',
      nextRouteId: 'P16-039',
      type: 'explanation',
      title: 'Medicijnen tegen een depressie (antidepressiva)',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>
            Medicijnen tegen een depressie heten antidepressiva.
            Door deze medicijnen kunnen de klachten van een depressie minder worden.
            Je wordt dan minder somber. En je krijgt weer interesse in de dingen om je heen.
          </p>

          <p>
            Je kunt medicijnen krijgen bij een ernstige depressie.
            Of als een behandeling zonder medicijnen te weinig helpt.
          </p>

          <p>
            Met je arts bespreek je altijd of je medicijnen wilt gaan slikken.
            En welke medicijnen voor jou dan het beste zijn.
          </p>

          <p>
            Let op: sommige middelen die je zonder recept kunt kopen, kun je beter niet gebruiken als je ook medicijnen tegen een depressie slikt.
            Ga ze niet zomaar gebruiken zonder met je arts te overleggen. Bijvoorbeeld:
          </p>
          <ul>
            <li>pijnstillers zoals ibuprofen, naproxen en diclofenac (NSAID's)</li>
            <li>passiflora, valeriaan en sint-janskruid (hypericum)</li>
          </ul>

          <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Vergoeding</h2>
          <p style="margin-top: 0;">
            Medicijnen tegen een depressie worden betaald door je zorgverzekering.
            De kosten van de medicijnen gaan wel af van het eigen risico bij je zorgverzekering.
          </p>

          <p>Je apotheek kan je uitleggen wat de kosten zijn.</p>
        </div>
      `,
      image: {
        src: `${process.env.PUBLIC_URL}/img/depressie-stap-4_7.webp`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-4/bijwerkingen-van-medicijnen-tegen-een-depressie',
      routeId: 'P16-039',
      nextRouteId: 'P16-040',
      type: 'explanation',
      title: 'Bijwerkingen van medicijnen tegen een depressie',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Medicijnen tegen een depressie kunnen bijwerkingen geven. Vaak gebeurt dat in de eerste weken dat je het medicijn slikt. Vaak nog voordat je je door de medicijnen beter voelt.</p>

          <p>
            De bijwerkingen verschillen per medicijn.
            Ze kunnen later minder worden of helemaal verdwijnen.
            Het is niet altijd duidelijk of iets een bijwerking is of een klacht die door de depressie komt.
          </p>

          <p style="margin-bottom: 0;">
            Bijwerkingen die mensen vaak krijgen zijn:
          </p>
          <ul style="margin-top: 0;">
            <li>misselijk zijn</li>
            <li>een droge mond</li>
            <li>slaperig zijn of juist niet kunnen slapen</li>
            <li>moe zijn</li>
            <li>je zenuwachtig voelen</li>
            <li>banger zijn (dit wordt na 2 weken weer minder)</li>
            <li>minder zin in seks</li>
            <li>minder stijve penis</li>
            <li>problemen met klaarkomen</li>
            <li>trillen</li>
          </ul>

          <p style="margin-bottom: 0;">
            Sommige mensen krijgen deze bijwerkingen als ze net met medicijnen tegen een depressie zijn begonnen:
          </p>
          <ul style="margin-top: 0;">
            <li>extra somber of onrustig worden</li>
            <li>meer denken aan de dood</li>
          </ul>
          <p>
            Dit gebeurt vooral bij mensen tussen 18 en 25 jaar.
            De huisarts of psychiater maakt dan vaker een afspraak met je om te kijken of je vaak aan de dood denkt en of dat verandert.
          </p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-4/hoe-gaat-het-verder-als-je-medicijnen-tegen-een-depressie-gaat-gebruiken-1',
      routeId: 'P16-040',
      nextRouteId: 'P16-041',
      type: 'explanation',
      title: 'Hoe gaat het verder als je medicijnen tegen een depressie gaat gebruiken?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <ul>
          <li>In het begin praat je elke week of elke 2 weken met je arts over hoe het gaat.</li>
          <li>Heb je last van bijwerkingen? Zeg het tegen je arts.</li>
          <li>Na 4 tot 6 weken moet duidelijk worden of de medicijnen werken. Als je dan nog niets merkt, dan is de kans groot dat dit medicijn niet bij jou gaat werken.</li>
          <li>Soms is het nodig om de eerste weken ook medicijnen te slikken waar je rustig van wordt. Bijvoorbeeld als je niet kunt slapen of erg bang of onrustig bent. Deze medicijnen kunnen je suf maken. Je kunt er ook verslaafd aan raken. Overleg daarom altijd met je arts hoe je deze medicijnen moet slikken.</li>
          <li>Als je merkt dat het medicijn tegen de depressie helpt, dan blijf je het nog 6 maanden of langer slikken. Bij een volgende depressie blijf je het een jaar of langer slikken. Je spreekt met je arts af wanneer je dan langskomt om te bespreken hoe het gaat.</li>
          <li>Als het nodig is, zorgt je arts dat je meer of minder van het medicijn krijgt.</li>
          <li>Helpt het medicijn niet genoeg? Dan kun je een ander medicijn of een andere behandeling proberen.</li>
          <li>Als het beter met je gaat, kun je samen met je arts een plan maken om met de medicijnen te stoppen.</li>
        </ul>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-4/vraag-1',
      routeId: 'P16-041',
      nextRouteId: 'P16-042',
      type: 'question',
      hideFromOverview: false,
      title: 'Wat vind jij ervan om je depressie met medicijnen te behandelen?',
      description:
        '<p>Schrijf hieronder op wat jij de voordelen en nadelen vindt van medicijnen tegen een depressie</p>',
      descriptionAlign: 'left',
      questions: [
        {
          type: 'textarea',
          placeholder: 'Schrijf hier je antwoord',
          title: 'Voordelen',
        },
        {
          type: 'textarea',
          placeholder: 'Schrijf hier je antwoord',
          title: 'Nadelen',
        },
      ],
      showTextArea: true,
      textAreaLabel: 'Waarom wil je dat het liefst?',
      button: 'Volgende',
    },
    {
      path: '/stap-4/meer-informatie-en-contact',
      routeId: 'P16-042',
      nextRouteId: 'P16-043',
      type: 'explanation',
      title: 'Meer informatie en contact',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <h2 style="font-size: 18px; line-height: 1.6">Meer informatie en contact</h2>
          <ul>
            <li>
              Het kan veel helpen om te praten met mensen die zelf ook een depressie hebben. Of met mensen die een depressie hebben gehad. Je kunt deze mensen vinden via de <a href='https://depressievereniging.nl/' target='_blank'>Depressie Vereniging</a>.
            </li>
            <li>
              Meer informatie: <a href='https://mindblue.nl/' target='_blank'>MIND blue</a> en <a href='https://nedkad.nl/' target='_blank'>Nederlands kenniscentrum Angst en Depressie</a>.
            </li>
            <li>
              Zelftest en online cursus: <a href='https://www.kleurjeleven.nl/' target='_blank'>Kleurjeleven</a>.
            </li>
            <li>
              Online trainingen op <a href='https://www.mentaalvitaal.nl/oefenen' target='_blank'>Mentaalvitaal</a>.
            </li>
          </ul>

          <h2 style="font-size: 18px; line-height: 1.6">Een psycholoog kiezen</h2>
          <ul>
            <li>
              Gegevens van psychologen, psychotherapeuten en psychiaters: <a href='https://kiezenindeggz.nl/aandoening/depressie' target='_blank'>Kiezen in de ggz</a> (18 jaar en ouder)
            </li>
            <li>
              Hier kun je opzoeken of de psycholoog die jij wilt kiezen op de speciale lijst van de overheid staat: <a href='https://www.bigregister.nl/' target='_blank'>BIG-register.nl</a>.
            </li>
          </ul>

          <h2 style="font-size: 18px; line-height: 1.6">Running-therapie</h2>
          <p>
            Informatie over een behandeling met hardlopen: <a href='https://runningtherapie-nederland.nl' target='_blank'>Runningtherapie Nederland</a>.
          </p>

          <h2 style="font-size: 18px; line-height: 1.6">Vaktherapie</h2>
          <p>
            Informatie over vaktherapie: <a href='https://www.vaktherapie.nl/' target='_blank'>vaktherapie.nl</a>
          </p>
      `,
      button: 'Ga verder',
    },
    {
      path: '/print-overview',
      routeIndex: '5',
      routeId: 'P16-043',
      nextRouteId: 'end',
      type: 'end',
      header: {
        subtitle: 'Einde keuzehulp',
        title: 'Alsjeblieft, je antwoorden bij deze keuzehulp',
        description: `
          <div>
            <p>
              Je bent klaar met de keuzehulp. Bespreek met je arts hoe je nu denkt over behandelingen bij depressie. En welke behandeling je wilt proberen.
            </p>
            <p>
              Heb je nog vragen? Kijk dan op Thuisarts.nl bij <a href='http://www.thuisarts.nl/depressie' target='_blank'>Depressie</a>. Of stel ze aan je arts.
            <p>
          </div>
        `,
      },
    },
  ],
}

export default depressie
